import { Box, BoxProps } from "@chakra-ui/react";
import { FiFileText } from "react-icons/fi";

export const FileTextIcon = (props: BoxProps) => {
  return <Box as={FiFileText} height="20px" width="20px" {...props} />;
};
